import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProjectsListScreen from './ProjectsListScreen';
import ProjectDetailsScreen from './details/ProjectDetailsScreen';
import ProjectSettingsScreen from './settings/ProjectSettingsScreen';

export default function ProjectsRouter() {
	return (
		<Routes>
			<Route path={'/'} element={<ProjectsListScreen />} />
			<Route path={'/settings/*'} element={<ProjectSettingsScreen />} />
			<Route path={':projectId'} element={<ProjectDetailsScreen />} />
		</Routes>
	);
}
